var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"box"},[_c('span',{staticClass:"submenu-banner-title"},[_c('em',{staticClass:"large"},[_vm._v("专业")]),_vm._v("服务")]),_c('span',{staticClass:"line"})])]),_c('div',{staticClass:"shadow"})])
}]

export { render, staticRenderFns }